export default "__VITE_ASSET__Cp9zYSA5__"